/**
 * InstaZ device constants and helpers.
 *
 * InstaZ exams produce a dedicated "Retinal Imaging Report - Remidio Insta Z" PDF
 * that must look identical to the one generated by the InstaZ desktop app. The
 * report itself is built by src/utils/instaZReportGenerator.js (a port of the
 * desktop app's jsPDF generator). Everything InstaZ-specific keys off
 * isInstaZDevice(deviceType) so other devices remain untouched.
 */

export const INSTAZ = "INSTAZ";

export function isInstaZDevice(deviceType) {
  if (!deviceType) return false;
  if (Array.isArray(deviceType)) return deviceType.includes(INSTAZ);
  return deviceType === INSTAZ;
}
